import html2canvas from 'html2canvas-pro'

export const createArrayWithEmptyCells = (count = 1) => {
  return Array(count).fill(null)
}

export const buildWorksheetUrl = (grid) => {
  const url = new URL(window.location.origin + Drupal.url('worksheet'))

  for (const [index, item] of grid.entries()) {
    url.searchParams.set(`t[${index}]`, item?.id ?? '')
  }

  return url.toString()
}

export const share = (grid) => {
  window.open(buildWorksheetUrl(grid))
}

export const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
  } catch(error) {
    console.error(error)
  }
}

export const saveGridImage = async (element) => {
  const canvas = await html2canvas(element, {
    scale: Math.max(window.devicePixelRatio, 2),
    logging: false,
  })
  const imageDataUrl = canvas.toDataURL('image/jpeg')
  const downloadLink = document.createElement('a')
  downloadLink.download = 'worksheet.jpg'
  downloadLink.href = imageDataUrl
  document.body.appendChild(downloadLink)
  downloadLink.click()
  document.body.removeChild(downloadLink)
}
